import { shallowEqual, toArray, memoize } from '../../utilities';

export const defaultGlobalPosition = {
  originX: undefined,
  originY: undefined,
  overlayX: '50%',
  overlayY: '50%',
  offsetX: '-50%',
  offsetY: '-50%'
};

export const defaultConnectedPosition = {
  originX: 'center', // start, center, end
  originY: 'top', // top, center, bottom
  overlayX: 'center', // start, center, end
  overlayY: 'bottom', // top, center, bottom
  offsetX: 0, // number, positive/negative
  offsetY: 0 // number, positive/negative
};

const withDefaultPosition = (position, strategy = 'connected') => {
  const defaultPosition = strategy === 'connected' ? defaultConnectedPosition : defaultGlobalPosition;

  return {
    ...defaultPosition,
    ...position
  };
};

export const getMemoizedPositions = memoize(
  (positions, positionStrategy) => {
    return toArray(positions).map(pos => withDefaultPosition(pos, positionStrategy));
  },
  (...args) => {
    let [positions, positionStrategy] = args;
    positions = toArray(positions);
    return [positionStrategy, JSON.stringify(positions)];
  }
);

export function areConfigsEqual(conf1 = {}, conf2 = {}) {
  return Object.entries(conf1).every(([key, val1]) => {
    const val2 = conf2[key];

    if (key === 'positions') {
      const pos1 = toArray(val1);
      const pos2 = toArray(val2);

      return pos1.length === pos2.length && pos1.every((pos, i) => shallowEqual(pos, pos2[i]));
    }

    if (/style$/i.test(key)) {
      return shallowEqual(val1, val2);
    }

    return val1 === val2;
  });
}
